import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-8 pb-lg-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Your Are Done!")
], -1)
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600 mb-5" }, " Your details will now be verified and we will reach out if we need any additional information. Thank You! ", -1)
const _hoisted_5 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6" }
const _hoisted_6 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, " Please review your details before submitting. ")
  ])
], -1)
const _hoisted_8 = { class: "mt-12" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ReviewItem = _resolveComponent("ReviewItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_ReviewItem, {
        label: "First Name",
        value: (_ctx.first_name as string)
      }, null, 8, ["value"]),
      _createVNode(_component_ReviewItem, {
        label: "Last Name",
        value: (_ctx.last_name as string)
      }, null, 8, ["value"]),
      _createVNode(_component_ReviewItem, {
        label: "Address",
        value: (_ctx.address as string)
      }, null, 8, ["value"]),
      _createVNode(_component_ReviewItem, {
        label: "Gender",
        value: _ctx.gender
      }, null, 8, ["value"]),
      _createVNode(_component_ReviewItem, {
        label: "D.O.B",
        value: _ctx.date_of_birth
      }, null, 8, ["value"]),
      _createVNode(_component_ReviewItem, {
        label: "Country",
        value: _ctx.citizenship_country
      }, null, 8, ["value"]),
      _createVNode(_component_ReviewItem, {
        label: "Document Type",
        value: _ctx.docType
      }, null, 8, ["value"]),
      _createVNode(_component_ReviewItem, {
        label: "ID Number",
        value: _ctx.id_number
      }, null, 8, ["value"]),
      (_ctx.uploads?.front)
        ? (_openBlock(), _createBlock(_component_ReviewItem, {
            key: 0,
            label: "Front Document"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.uploads.front,
                class: "img-fluid"
              }, null, 8, _hoisted_9)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.uploads?.back)
        ? (_openBlock(), _createBlock(_component_ReviewItem, {
            key: 1,
            label: "Back Document"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.uploads.back,
                class: "img-fluid"
              }, null, 8, _hoisted_10)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.uploads?.selfie)
        ? (_openBlock(), _createBlock(_component_ReviewItem, {
            key: 2,
            label: "Selfie"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.uploads.selfie,
                class: "img-fluid"
              }, null, 8, _hoisted_11)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}